import IconActionButton from "./IconActionButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const EditIconButton = ({title, disabled = false, onClick}) => (
    <IconActionButton
        disabled={disabled}
        title={title}
        onClick={onClick}
        className="text-blue-800 ml-3"
    >
        <EditOutlinedIcon fontSize="small"/>
    </IconActionButton>
);

export default EditIconButton;
